import {gql} from "@apollo/client/core";
import {ProductDescriptionFragment} from "./product-description-fragment";
import {SupplementalInfoFragment} from "./supplemental-info-fragment";
import {ProductImageFragment} from "./product-image-fragment";
import {ProductPriceFragment} from "./product-price-fragment";
import {ProductVariantFragment} from "./product-variant-fragment";
import {ProductTagFragment} from "./product-tag-fragment";

//use this when needing everything, long description, tags, etc.
export const CartProductFullFragment = gql`
    fragment CartProductFullFragment on CartProduct {
        id
        marketProductId
        usanaId
        legacyProductKey
        productDescription {
            ...ProductDescriptionFragment
            longDescription
        }
        productQuantityCount
        productQuantityCountTranslationTag
        supplementalInfo {
            ...SupplementalInfoFragment
        }
        productImages {
            ...ProductImageFragment
        }
        productCategory {
            id
            name
        }
        price {
            usdPrice
            ...ProductPriceFragment
        }
        aoPrice {
            ...ProductPriceFragment
        }
        retailPrice {
            ...ProductPriceFragment
        }
        pcPrice {
            ...ProductPriceFragment
        }
        shopModes
        editable
        removable
        eligibleForFreeShipping
        featured
        productVariants {
            ...ProductVariantFragment
        }
        productTags {
            ...ProductTagFragment
        }
    }

    ${ProductDescriptionFragment}
    ${SupplementalInfoFragment}
    ${ProductImageFragment}
    ${ProductPriceFragment}
    ${ProductVariantFragment}
    ${ProductTagFragment}
`;
